import dayjs from 'dayjs';

export const getToday = () => {
	const currentTimeZone = dayjs().utcOffset() / 60;

	const todayDate = dayjs()
		.utc()
		.utcOffset(currentTimeZone * 60)
		.format('YYYY-MM-DD');

	return [todayDate, currentTimeZone] as const;
};
